import { render } from "./SideNav.vue?vue&type=template&id=74b99727&scoped=true"
import script from "./SideNav.vue?vue&type=script&lang=js"
export * from "./SideNav.vue?vue&type=script&lang=js"

import "./SideNav.vue?vue&type=style&index=0&id=74b99727&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b99727"],['__file',"src/components/mdbvue/pro/Navigation/SideNav.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74b99727"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74b99727', __exports__)) {
    api.reload('74b99727', __exports__)
  }
  
  module.hot.accept("./SideNav.vue?vue&type=template&id=74b99727&scoped=true", () => {
    api.rerender('74b99727', render)
  })

}


export default __exports__